import { eventTrack } from "helpers/ga4Helper";
import React, { Component } from "react";
import { Link } from "react-scroll";

export default class FooterSpy extends Component {
  render() {
    const openInNewTab = (url) => {
      window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
      <div className="d-flex">
        <div className="footer-links-div">

        <Link
  activeclass="nav-menu-item-active"
  to=""
  style={{ cursor: "pointer" }}
  offset={0}
  onClick={() => {
    openInNewTab("https://prigmar.com/what-is-prigmar")
    {
      eventTrack(
        "what-is-prigmar-Action",
        "what-is-prigmar",
        'none-logged-in-user',
        "+1",
        false,
        "+1"
      );
    }
  }}
>
  What is Prigmar?
</Link>

<Link
  activeclass="nav-menu-item-active"
  to=""
  style={{ cursor: "pointer" }}
  offset={0}
  onClick={() => {
    openInNewTab("https://prigmar.com/how-prigmar-works")
    {
      eventTrack(
        "how-prigmar-works-Action",
        "how-prigmar-works",
        'none-logged-in-user',
        "+1",
        false,
        "+1"
      );
    }
  }}
>
  How Prigmar works?
</Link>

<Link
  activeclass="nav-menu-item-active"
  to=""
  style={{ cursor: "pointer" }}
  offset={0}
  onClick={() => {
    openInNewTab("https://prigmar.com/offered-features")
    {
      eventTrack(
        "offered-features-Action",
        "offered-features",
        'none-logged-in-user',
        "+1",
        false,
        "+1"
      );
    }
  }}
>
  Offered Features
</Link>

<Link
  activeclass="nav-menu-item-active"
  to=""
  style={{ cursor: "pointer" }}
  offset={0}
  onClick={() => {
    openInNewTab("https://prigmar.com/services")
    {
      eventTrack(
        "services-Action",
        "services",
        'none-logged-in-user',
        "+1",
        false,
        "+1"
      );
    }
  }}
>
  Consultation Services
</Link>

<Link
  activeclass="nav-menu-item-active"
  to=""
  style={{ cursor: "pointer" }}
  offset={0}
  onClick={() => {
    openInNewTab("https://prigmar.com/supported-socialmedia")
    {
      eventTrack(
        "supported-socialmedia-Action",
        "supported-socialmedia",
        'none-logged-in-user',
        "+1",
        false,
        "+1"
      );
    }
  }}
>
  Supported Social Media
</Link>

<Link
  activeclass="nav-menu-item-active"
  to=""
  style={{ cursor: "pointer" }}
  offset={0}
  onClick={() => {
    openInNewTab("https://prigmar.com/supported-languages")
    {
      eventTrack(
        "supported-languages-Action",
        "supported-languages",
        'none-logged-in-user',
        "+1",
        false,
        "+1"
      );
    }
  }}
>
  Supported Languages
</Link>

          {/* <Link
          to="about"
          spy={true}
          smooth={true}
          duration={1500}
          style={{ cursor: "pointer" }}
        >
          About Us
        </Link> */}
        </div>
        <div className="footer-links-div ml-5">
        <Link
            activeclass="nav-menu-item-active"
            to=""
            style={{ cursor: "pointer" }}
            offset={0}
            onClick={() =>{
              openInNewTab("https://prigmar.com/pricing")
              {
                eventTrack(
                  "pricing-open-Action",
                  "pricing-open",
                  'none-logged-in-user',
                  "+1",
                  false,
                  "+1"
                );
              }
            }
            }
          >
            Pricing
          </Link>
          <Link
            activeclass="nav-menu-item-active"
            to=""
            style={{ cursor: "pointer" }}
            offset={0}
            onClick={() =>{
              openInNewTab("https://prigmar.com/contact")
              {
                eventTrack(
                  "demo-request-Action",
                  "demo-request",
                  'none-logged-in-user',
                  "+1",
                  false,
                  "+1"
                );
              }
            }
            }
          >
            Request a Demo
          </Link>

          <Link
            activeclass="nav-menu-item-active"
            to=""
            style={{ cursor: "pointer" }}
            offset={0}
            onClick={() =>{
              openInNewTab("https://prigmar.com/articles")
              {
                eventTrack(
                  "Open-Articles-Action",
                  "Open-Articles",
                  'none-logged-in-user',
                  "+1",
                  false,
                  "+1"
                );
              }
            }
            }
          >
            Learn more ...
          </Link>
        </div>
      </div>
    );
  }
}
